import * as React from 'react';
export const capitalcommunitySvg = React.forwardRef(
  function capitalcommunitySvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F5F6F8',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M10.894 20.697C8.273 19.121 6.5 16.242 6.5 13c0-4.97 4.03-9 9.06-9 1.41 0 2.728.318 3.925.894V9.03a11.614 11.614 0 0 0-3.03-.424c-1.682 0-3.243.364-4.713 1.106l-.848.41v10.575ZM21 11.273v10.773l-.833.363a10.514 10.514 0 0 1-4.546 1.046c-1.106 0-2.151-.152-3.136-.47v4.076c1.197.62 2.621.939 4.076.939 4.97 0 9.06-4.03 9.06-9-.121-3.273-1.954-6.197-4.621-7.727Z',
        fill: '#DE7205',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M16.803 10.076h-.318c-1.47 0-2.833.363-4.076.94v10.408a9.12 9.12 0 0 0 3.136.576 8.987 8.987 0 0 0 3.925-.894v-8.364h-2.667v-2.666Z',
        fill: '#03873D',
      }),
    );
  },
);
capitalcommunitySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var capitalcommunity = {
  category: 'brand',
  colorable: false,
  name: 'capitalcommunity',
  svg: capitalcommunitySvg,
};
